
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-registries/create",
      function () {
        return require("private-next-pages/my-registries/create/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-registries/create"])
      });
    }
  